import { Button, Modal, ModalBody, ModalFooter, ModalTitle, TextField } from '@symphony-ui/uitoolkit-components';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import Party from '../../../../../../models/Party';
import * as React from 'react';
import { sendError } from 'utils/messageUtils';
const PartyCreateModal = ({ callback, initialNames, onClose }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [name, setName] = React.useState(initialNames?.[0] ?? '');
    const onChange = React.useCallback((event) => {
        setName(event.target.value);
    }, []);
    const onClickSave = React.useCallback(() => {
        if (name !== '') {
            const newParty = new Party({ name: name, names: [name] });
            const requestInit = { body: JSON.stringify(newParty), headers: { 'Content-Type': 'application/json' }, method: 'POST' };
            const request = new ApiServerRequest('/syndicate/parties', requestInit);
            (async () => {
                try {
                    const body = await apiFetchJson(request);
                    callback(new Party(body));
                }
                catch (error) {
                    sendError("Unable to save unknown parties", error);
                }
            })();
        }
    }, [apiFetchJson, callback, name]);
    return (React.createElement(Modal, { show: true, size: 'small', onClose: onClose, closeButton: true },
        React.createElement(ModalTitle, null, "Create New Party"),
        React.createElement(ModalBody, null,
            React.createElement(TextField, { onChange: onChange, value: name })),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { onClick: onClickSave, size: 'small' }, "OK"))));
};
export default PartyCreateModal;
